import { ReactNode } from "react";
import { Button, ButtonProps, HBLoadingSpinnerOnly, Icon } from "~components";
import { Css, Palette } from "~generated/css";
import { useTestIds } from "~utils";

export type ModalProps = {
  children?: ReactNode;
  isOpen: boolean;
  close: () => void;
  title: ReactNode;
  description?: ReactNode;
  bg?: Palette;
  size?: {
    width: string;
    height: string;
    maxWidth?: string;
  };
  actionBtns?: ButtonProps[];
  // Shows left aligned loading spinner when actionBts exist
  loading?: boolean;
};

export function Modal(props: ModalProps) {
  const {
    children,
    isOpen,
    close,
    title,
    bg = Palette.White,
    size = { width: "100%", height: "100%", maxWidth: "auto" },
    description,
    actionBtns,
    loading,
  } = props;

  const tid = useTestIds(props, "modal");

  return (
    <>
      {isOpen && (
        <div
          css={
            Css.w(size.width).h(size.height).maxw(size.maxWidth).bgColor(bg).df.ma.fdc.px5.if(!actionBtns).py5.else.pt5
              .$
          }
          // Prevent modal interactions from closing overlay layer
          onClick={(e) => e.stopPropagation()}
          {...tid}
        >
          <div css={Css.px3.df.fdc.gap1.$}>
            <div css={Css.df.jcsb.aic.mb2.$}>
              {typeof title === "string" ? <h4 css={Css.t32.$}>{title}</h4> : title}
              <div css={Css.cursorPointer.$} onClick={close}>
                <Icon name="x-32" />
              </div>
            </div>
            {description && typeof description === "string" ? (
              <div css={Css.t14.gray.$}>{description}</div>
            ) : (
              description
            )}
          </div>
          {children}
          {actionBtns && (
            <div css={Css.df.aic.mx3.my5.gap1.if(!!loading).jcsb.else.jcfe.$}>
              {loading && (
                <div id="spinner-only" css={Css.df.wPx(48).hPx(48).$}>
                  <HBLoadingSpinnerOnly />
                </div>
              )}
              {actionBtns?.map((btn, i) => (
                <div css={Css.hPx(35).$}>
                  <Button btnFontSize="sm" {...btn} {...tid.button} />
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}
